import { CreateCorpResponse, CorpUIPayload } from 'src/types/Corp';
import {
  CateringServiceFeeResponseUI,
  CateringServiceFeePayloadUI,
} from 'src/types/CateringServiceFee';
import { updateCorporateDetails } from 'src/components/enterprise/features/Corporate/EditPage/functions/updateCorporateApi';
import { setCateringServiceFee } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/api/cateringServiceFeeApi';
import { enableUniversalAccounts } from 'src/components/enterprise/features/Corporate/components/Form/UniversalLogin/api/enableUniversalAccountsApi';

export type CorporateUpdateResult = {
  corpData: CreateCorpResponse;
  cateringServiceFeeData?: CateringServiceFeeResponseUI;
};

export const executeCorporateUpdate = async (
  corpId: string,
  corporateData: CorpUIPayload,
  serviceFee: CateringServiceFeePayloadUI,
  shouldEnableUniversalAccounts: boolean
): Promise<void> => {
  const temServiceFee = { ...serviceFee };
  await updateCorporateDetails(corpId, corporateData);
  temServiceFee.corpId = corpId;
  await setCateringServiceFee(temServiceFee);

  if (shouldEnableUniversalAccounts) {
    await enableUniversalAccounts(corpId);
  }
};
